var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.promotions
    ? _c(
        "section",
        { staticClass: "section-promotions px-4" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 p-2" },
              [
                _c(
                  "carousel",
                  {
                    attrs: {
                      perPage: _vm.$mq.phone ? 1 : 3,
                      autoplay: true,
                      centerMode: true,
                      autoplayHoverPause: true,
                      navigationEnabled: true,
                      paginationEnabled: false,
                      loop: true,
                      autoplayTimeout: 3000,
                      scrollPerPage: false,
                      mouseDrag: true,
                      touchDrag: true
                    }
                  },
                  [
                    _vm._l(_vm.promotions, function(promotion) {
                      return [
                        _c(
                          "slide",
                          {
                            on: {
                              slideclick: function($event) {
                                return _vm.openUrl(promotion)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "m-2 pointer-item" }, [
                              _c("img", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy",
                                    value: promotion.image_xl,
                                    expression: "promotion.image_xl"
                                  }
                                ],
                                staticClass: "img-fluid rounded",
                                attrs: { alt: "" }
                              })
                            ])
                          ]
                        )
                      ]
                    })
                  ],
                  2
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "sweet-modal",
            {
              ref: "modal",
              attrs: {
                "overlay-theme": "dark",
                width: _vm.modalWidth,
                "hide-close-button": "",
                "enable-mobile-fullscreen": false
              },
              on: {
                close: function($event) {
                  return _vm.setSelectedPromotionId()
                }
              }
            },
            [
              _c("template", { staticClass: "p-0", slot: "default" }, [
                _c("div", { staticClass: "text-right mb-1" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.closeModal()
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "fas fa-2x fa-times-circle text-white"
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.selectedPromotion
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.selectedPromotion.page_url,
                            target: "_blank"
                          },
                          on: {
                            click: function($event) {
                              return _vm.closeModal()
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "img-fluid img-promotion",
                            attrs: {
                              src: _vm.selectedPromotion.image_popup,
                              alt: ""
                            }
                          })
                        ]
                      )
                    ])
                  : _vm._e()
              ])
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48b7717d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48b7717d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/promotion/Slider.vue
// module id = 1440
// module chunks = 0